import React, { useContext, useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { CoolFarmCropOptionsContext } from '../..'
import { Grid } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import InfoPopup from '~/components/InfoPopup'

interface Props {
  index: number
}

const FieldOperation: React.FC<Props> = ({ index }) => {
  const { t } = useTranslation()
  const { control, setValue } = useFormContext()
  const options = useContext(CoolFarmCropOptionsContext)

  const wathcMachineCategoryId = useWatch({ control, name:`fieldOperations[${index}].cftFieldTypeOperationId` })
  const watchMachineId = useWatch({ control, name: `fieldOperations[${index}].id` })

  const machineCatOption = options?.fieldOperationTypes?.find(fieldType => fieldType.id === wathcMachineCategoryId)
  const machineOptions = machineCatOption?.operations?.map(operation => ({ value: operation.id, text: operation.label }))
  const selectedMachine = machineCatOption?.operations?.find(machineOpt => machineOpt.id === watchMachineId)

  useEffect(() => {
    if(selectedMachine && selectedMachine.isBaler === 0) {
      setValue(`fieldOperations[${index}].numberOfBales`, '')
    }
  }, [watchMachineId, selectedMachine])

  const fuelTypeOptions = options?.fieldOperationFuelTypes?.map(type => ({
    key: type.key,
    value: type.key,
    text: type.label
  })) || []

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={8}>
          <FormFields.Select
            search
            scrolling
            label={t('Machine Category')}
            upward
            placeholder={t('Select category')}
            noErrorMessage
            withoutAsterisk
            rules={{
              required: true
            }}
            options={options?.fieldOperationTypes.map(fieldType => ({ value: fieldType.id, text: fieldType.label }))}
            name={`fieldOperations[${index}].cftFieldTypeOperationId`}
          />
        </Grid.Column>
        <Grid.Column width={8}>
          <FormFields.Select
            search
            rules={{
              required: true
            }}
            scrolling
            upward
            withoutAsterisk
            label={t('Machine')}
            noErrorMessage
            placeholder={t('Select machine')}
            disabled={!wathcMachineCategoryId}
            options={machineOptions || []}
            name={`fieldOperations[${index}].id`}
          />
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={8}>
          <FormFields.Select
            control={control}
            name={`fieldOperations[${index}].fuelType`}
            withoutAsterisk
            label={t('Fuel Type')}
            options={fuelTypeOptions}
            rules={{
              required: true
            }}
            placeholder={t('Select fuel type')}
            noErrorMessage
          />
        </Grid.Column>
        <Grid.Column width={8}>
          <FormFields.Input
            control={control}
            name={`fieldOperations[${index}].numberOfOperations`}
            withoutAsterisk
            label={
              <div style={{ display: 'flex', gap: 5 }}>
                <div>{t('Number of Operations')}</div>
                <InfoPopup
                  content={t('Number of times field operation completed during the growing cycle for this crop.')}
                  styleIcon={{ fontSize: '1.2em' }}
                />
              </div>
            }
            placeholder={t('Number')}
            typeInput='controled'
            rules={{
              required: true
            }}
            noErrorMessage
          />
        </Grid.Column>
      </Grid.Row>

      {selectedMachine?.isBaler === 1 && (
        <Grid.Row>
          <Grid.Column width={8}>
            <FormFields.Input
              control={control}
              name={`fieldOperations[${index}].numberOfBales`}
              withoutAsterisk
              label={t('Number of bales per ha')}
              rules={{
                required: true
              }}
              placeholder={t('Number')}
              typeInput='controled'
              noErrorMessage
            />
          </Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  )
}
export default FieldOperation